import { render } from "./FullPicture.vue?vue&type=template&id=d2bad046&lang=pug"
import script from "./FullPicture.vue?vue&type=script&lang=ts"
export * from "./FullPicture.vue?vue&type=script&lang=ts"

import "./FullPicture.vue?vue&type=style&index=0&id=d2bad046&lang=scss"
script.render = render

export default script